module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/book-appointment/book-appointment.component.scss
// module id = ./src/app/admin/book-appointment/book-appointment.component.scss
// module chunks = main